import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { takeReturn } from '../contexts/AuthContext';

const API = '/api';

export default function TokenCallback() {
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processToken = async () => {
      const hash = window.location.hash;
      const tokenMatch = hash.match(/token=([^&]+)/);
      
      if (!tokenMatch) {
        window.location.replace('/');
        return;
      }

      const token = tokenMatch[1];
      console.log('[auth] received token, verifying...');
      
      // Store token FIRST
      localStorage.setItem('logos_session_token', token);
      
      try {
        const response = await fetch(`${API}/auth/me`, {
          credentials: 'include',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (response.ok) {
          const userData = await response.json();
          console.log('[auth] token verified, user:', userData.username);
          setUser(userData);
        } else {
          console.error('[auth] token verification failed, status:', response.status);
          localStorage.removeItem('logos_session_token');
        }
      } catch (error) {
        console.error('[auth] token verification error:', error);
        localStorage.removeItem('logos_session_token');
      }
      
      // Clear hash and do a full page navigation to ensure clean state; return
      // to the page that asked for sign-in (only ever a path on this site)
      window.location.replace(takeReturn());
    };

    processToken();
  }, [setUser, checkAuth]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <p className="text-[#888888] lowercase animate-pulse">authenticating...</p>
    </div>
  );
}
